<template>
   <div style="width: 100%; height: 100%;">
      <div class="custom-container">
         <v-row no-gutters justify="center">
            <v-col cols="12" md="8">
               <v-card flat>
                  <v-card-title class="headline">
                     {{ $route.params.id ? 'Kategorie bearbeiten' : 'Kategorie erstellen' }}
                  </v-card-title>
               </v-card>
               <v-card flat>
                  <v-card-text>
                     <v-text-field label="Name" v-model="item.name" outlined/>
                     <v-textarea label="Beschreibung" v-model="item.description" outlined/>
                  </v-card-text>
                  <v-card-text>
                     <v-row dense>
                        <v-col cols="12" md="auto">
                           <v-btn color="error" outlined :to="{name: 'IdeasWorkbenchCategoriesShow', params: {id: this.$route.params.id}}">Abbrechen</v-btn>
                        </v-col>
                        <v-col cols="12" md="auto">
                           <v-btn color="success" depressed @click="$route.params.id ? updateCategory() : storeCategory()">Speichern</v-btn>
                        </v-col>
                     </v-row>
                  </v-card-text>
               </v-card>
            </v-col>
         </v-row>
      </div>
   </div>
</template>

<script>
export default {
   props: [],
   name: "",
   data: () => ({
      item: {},
   }),
   created() {
      if (this.$route.params.id) {
         this.showCategory();
      }
   },
   methods: {
      showCategory() {
        this.axios.get('/ideas-categories/' + this.$route.params.id).then((r) => {
           this.item = r.data.data;
        }).catch(() => {
           this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.')
        })
      },
      storeCategory() {
         this.axios.post('/ideas-categories', {
            'item' : this.item
         }).then((r) => {
            this.$toast.success('Die Kategorie wurde erfolgreich gespeichert.');
            this.$router.push({name: 'IdeasWorkbenchCategoriesShow', params: {id: r.data.id}});
         }).catch(() => {
            this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
         })
      },
      updateCategory() {
         this.axios.patch('/ideas-categories/' + this.$route.params.id, {
            'item' : this.item
         }).then((r) => {
            this.$toast.success('Die Kategorie wurde erfolgreich gespeichert.');
            this.$router.push({name: 'IdeasWorkbenchCategoriesShow', params: {id: r.data.id}});
         }).catch(() => {
            this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
         })
      },
   },
}
</script>

<style scoped>

</style>
